import { LATITUDE, VISION_ID } from 'core/constants/products'
import { ADD_PLAN, REMOVE_PLAN } from 'messages'
import toastNotification from 'pug/toastNotification'
import getById from 'utils/DOM/getById'
import store from 'utils/store/withMiddleware'
function handleToggleAddonModal() {
  const planId = +this.getAttribute('data-context')
  const ids = this.getAttribute('data-ids').split(',')
  const addonId = +ids[0]
  const visionId = +ids[1]
  const visionInput = getById(`vision-${planId}-addon-${addonId}`)

  if (visionInput) {
    visionInput.checked = false
  }

  const deletePlans = this.classList.contains('remove')

  const {
    addonsByPlan,
    visionAddons,
    latitudeAddons,
    dentalAddons,
    plans
  } = store.getState()

  const latitudePlan = latitudeAddons[planId]
  const dentalPlan = dentalAddons[planId]
  const visionPlan = visionAddons[planId]

  const addons =
    plans[addonId].productId === LATITUDE ? [dentalPlan, visionPlan] : [latitudePlan]

  if (!deletePlans) {
    addons.push(addonId)

    if (!visionPlan && visionId) {
      addons.push(VISION_ID)
      visionInput.checked = true
    }
  }

  addonsByPlan[planId] = addons.filter(Boolean)

  store.update({ addonsByPlan })

  toastNotification(deletePlans ? REMOVE_PLAN : ADD_PLAN)
}

export default handleToggleAddonModal
